/**
  * @function getPhone
  * @param {object} values
  * @param {string} values.phoneNumber
  * @returns {{
*   type: 'MOBILE',
*   number: string,
*   countryCode: '49',
* }}
*/
function getPhone({
  phoneNumber,
}) {
  return {
    type: 'MOBILE',
    number: phoneNumber,
    countryCode: '49',
  };
}

export default getPhone;
